import React, { useState, useEffect } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { Select } from "antd";
import Stack from "@mui/material/Stack";

const SelectBankAccountPurpose = (props) => {
  const [bankAccountPurposes, setBankAccountPurposes] = useState(JSON.parse(window.localStorage.getItem("bankAccountPurposes")));
  const [selectedValue, setSelectedValue] = useState(undefined)


  useEffect(() => {
    setSelectedValue(props.currentPurposeId)
  }, [props.currentPurposeId]);

  return (
    <>
      <Stack direction="row" spacing={2}>

        <Select
          style={{ width: "100%" }}
          value={selectedValue}
          showSearch
          optionFilterProp="label"
          dropdownMatchSelectWidth={false}
          onChange={(e) => {
            setSelectedValue(e);
            if (props.onChange) {
              props.onChange(e);
            }
          }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={[...bankAccountPurposes]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((purpose) => ({
              value: purpose.id,
              label: purpose.name,
            }))}
          placeholder="Select Purpose"
        />


        {props.onSubmit !== undefined && (
          <LoadingButton
            loading={props.loading || false}
            sx={{
              fontSize: 14,
              textTransform: "none",
              width: "100px",
            }}
            disableElevation
            loadingPosition="start"
            fullWidth
            size="small"
            variant="contained"
            color="primary"
            onClick={() => props.onSubmit(selectedValue)}
            htmltype="submit"
            disabled={props.loading || false}
          >
            Apply
          </LoadingButton>
        )}
      </Stack>
    </>
  );
};

export default SelectBankAccountPurpose;